import Vue from 'vue';
import Vuex from 'vuex';

import {
  useAccessor,
  getterTree,
  mutationTree,
  actionTree
} from 'typed-vuex';

Vue.use(Vuex);

const getDefaultState = () => {
  return {
    newFlag: '0',
    newKyokaNo1: '',
    newKyokaNo2: '',
    newSinseiName: '',
    newWasteHandle: '',
    newWasteHandleDisp: '',
    newSector: '',
    newSectorDisp: '',
    newPermissionLimit: '',
    newPermissionLimitDisp: '',
    newTel: '',
    newKindValue: '0',
    newTorikindValue: '0',
    newGyokindValue: '0',
    newSinseisyaName: '',
    newCheckedTanto: '0',
    newCheckedRiyou: '0',
    newTantoName: '',
    newTantoNameU: '',
    newCheckedTantoU: '0',
    newCheckedRiyouU: '1',
    newTantoTel: '',
    newTantoTelU: '',
    newYoyakuYmd: '',
    newPlaceKindValue: '0',
    newPostKindValue: '0',
    newPopupFlag: '0',
    changeInfo: {
      reservedNum: '',
      petitionName: '',
      petitionPlace: '0',
      petitionType: '0',
      permissionNum1: '',
      permissionNum2: '',
      petitionOfficer: '',
      officerType: [],
      permissionLimit: '',
      petitionDivision: '0'
    }
  };
};

const state = () => getDefaultState();

// Getter
const getters = getterTree(state, {
});

// Mutation
const mutations = mutationTree(state, {
  resetState(state) {
    Object.assign(state, getDefaultState());
  },

  setReservedNum(state, newValue) {
    state.changeInfo.reservedNum = newValue;
  },
  setPetitionName(state, newValue) {
    state.changeInfo.petitionName = newValue;
  },
  setPetitionPlace(state, newValue) {
    state.changeInfo.petitionPlace = newValue;
  },
  setPetitionType(state, newValue) {
    state.changeInfo.petitionType = newValue;
  },
  setPermissionNum1(state, newValue) {
    state.changeInfo.permissionNum1 = newValue;
  },
  setPermissionNum2(state, newValue) {
    state.changeInfo.permissionNum2 = newValue;
  },
  setPetitionOfficer(state, newValue) {
    state.changeInfo.petitionOfficer = newValue;
  },
  setOfficerType(state, newValue) {
    state.changeInfo.officerType = newValue;
  },
  setPermissionLimit(state, newValue) {
    state.changeInfo.permissionLimit = newValue;
  },
  setPetitionDivision(state, newValue) {
    state.changeInfo.petitionDivision = newValue;
  },

  setNewFlag(state, flag) {
    state.newFlag = flag;
  },
  setNewKyokaNo1(state, kyokaNo1) {
    state.newKyokaNo1 = kyokaNo1;
  },
  setNewKyokaNo2(state, kyokaNo2) {
    state.newKyokaNo2 = kyokaNo2;
  },
  setNewSinseiName(state, sinseiName) {
    state.newSinseiName = sinseiName;
  },
  setNewWasteHandle(state, wasteHandle) {
    state.newWasteHandle = wasteHandle;
  },
  setNewWasteHandleDisp(state, wasteHandleDisp) {
    state.newWasteHandleDisp = wasteHandleDisp;
  },
  setNewSector(state, sector) {
    state.newSector = sector;
  },
  setNewSectorDisp(state, sectorDisp) {
    state.newSectorDisp = sectorDisp;
  },
  setNewPermissionLimit(state, permissionLimit) {
    state.newPermissionLimit = permissionLimit;
  },
  setNewPermissionLimitDisp(state, permissionLimitDisp) {
    state.newPermissionLimitDisp = permissionLimitDisp;
  },
  setNewTel(state, tel) {
    state.newTel = tel;
  },
  setNewKindValue(state, kindValue) {
    state.newKindValue = kindValue;
  },
  setNewTorikindValue(state, torikindValue) {
    state.newTorikindValue = torikindValue;
  },
  setNewGyokindValue(state, gyokindValue) {
    state.newGyokindValue = gyokindValue;
  },
  setNewSinseisyaName(state, sinseisyaName) {
    state.newSinseisyaName = sinseisyaName;
  },
  setNewCheckedTanto(state, checkedTanto) {
    state.newCheckedTanto = checkedTanto;
  },
  setNewCheckedRiyou(state, checkedRiyou) {
    state.newCheckedRiyou = checkedRiyou;
  },
  setNewTantoName(state, tantoName) {
    state.newTantoName = tantoName;
  },
  setNewTantoNameU(state, tantoNameU) {
    state.newTantoNameU = tantoNameU;
  },
  setNewCheckedTantoU(state, checkedTantoU) {
    state.newCheckedTantoU = checkedTantoU;
  },
  setNewCheckedRiyouU(state, checkedRiyouU) {
    state.newCheckedRiyouU = checkedRiyouU;
  },
  setNewTantoTel(state, tantoTel) {
    state.newTantoTel = tantoTel;
  },
  setNewTantoTelU(state, tantoTelU) {
    state.newTantoTelU = tantoTelU;
  },
  setNewYoyakuYmd(state, yoyakuYmd) {
    state.newYoyakuYmd = yoyakuYmd;
  },
  setNewPlaceKindValue(state, placeKindValue) {
    state.newPlaceKindValue = placeKindValue;
  },
  setNewPostKindValue(state, postKindValue) {
    state.newPostKindValue = postKindValue;
  },
  setNewPopupFlag(state, popupFlag) {
    state.newPopupFlag = popupFlag;
  }
});

const actions = actionTree(
  { state, getters, mutations },
  { }
);

const storePattern = {
  state,
  mutations,
  actions
};

const store = new Vuex.Store(storePattern);

export const accessor = useAccessor(store, storePattern);

// Optionally, inject accessor globally
Vue.prototype.$accessor = accessor;

export default store;
